import {
  Facebook,
  Instagram,
  Negative,
  Order,
  Unknown,
} from '@bufferapp/ui/Icon'

import { env } from '~/env'

// API
export const API_GATEWAY = env.VITE_GRAPHQL_API

// Errors.
export const ERROR_GENERIC = 'ERROR_GENERIC'
export const ERROR_CHANNEL_DISCONNECTED = 'ERROR_CHANNEL_DISCONNECTED'
export const ERROR_SEND_GENERIC = 'ERROR_SEND_GENERIC'
export const ERROR_SEND_COMMENT_DELETED = 'ERROR_SEND_COMMENT_DELETED'
export const ERROR_SEND_EMPTY_TEXT = 'ERROR_SEND_EMPTY_TEXT'
export const ERROR_SEND_PERMISSON = 'ERROR_SEND_PERMISSON'
export const ERROR_TARGET_USER_MENTION = 'ERROR_TARGET_USER_MENTION'

// Images.
export const INBOX_EMPTY_IMG =
  'https://static.buffer.com/images/engage/inbox-empty.jpeg'
export const INBOX_ZERO_IMG =
  'https://static.buffer.com/images/engage/inbox-zero.jpeg'

// Available emojis.
export const EMOJIS = ['❤️', '🙌', '🔥', '👏', '🙏', '😍', '😮', '😂']

// Available labels.
export const LABELS = [
  {
    id: 'NEGATIVITY',
    color: '#E0364F',
    icon: Negative,
    help: 'Potential negativity',
    filterStr: 'negative',
  },
  {
    id: 'ORDER',
    color: '#87C221',
    icon: Order,
    help: 'Potential sale or customer',
    filterStr: 'order related',
  },
  {
    id: 'QUESTION',
    color: '#FF702C',
    icon: Unknown,
    help: 'Question',
    filterStr: 'question',
  },
]

export const SERVICE_DEFAULTS = {
  instagram: {
    label: 'Instagram',
    postsPerPage: 15,
    postsPerRow: 3,
    imagesW: 145,
    imagesH: 145,
    images: [
      'https://static.buffer.com/images/engage/fallback-post-thumbnail.png',
    ],
    icon: Instagram,
    baseURL: 'https://instagram.com',
  },
  facebook: {
    label: 'Facebook',
    postsPerPage: 10,
    postsPerRow: 2,
    imagesW: 218,
    imagesH: 150,
    images: [
      'https://static.buffer.com/images/engage/default-grid-thumbnail-01.png',
      'https://static.buffer.com/images/engage/default-grid-thumbnail-02.png',
      'https://static.buffer.com/images/engage/default-grid-thumbnail-03.png',
    ],
    icon: Facebook,
    baseURL: 'https://facebook.com',
  },
}
